export const CHILD_CONSTANTS = {
    SUCCESS: 'success',
    CHILD_OTP_LABEL: 'Enter OTP sent to your registered mobile number',
    CHILD_OTP: 'Enter OTP'
}

export const CHILD_ERROR_MESSAGES = {
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again later.',
    SUCCESS_MSG: 'Child details has been successfully updated',
    GET_API_ERROR_MESSAGE: (apiName: string) => `Error in retrieving data from the ${apiName} API`,
    POST_API_ERROR_MESSAGE: (apiName: string) => `Error in creating ${apiName}.`,
    CHILD_AADHAR_NUMBER_ERROR: 'Aadhaar number must contain 12 digits. Enter a valid Aadhaar number.',
    CHILD_API_ERROR: 'Child Aadhar OTP Generation-/child/kyc/otp/verify',
    ABHA_LIMIT_EXCEEDED: "Child ABHA’s account limit has been exceeded for the requested Abha Number",
} 

export const CHILD_SUCCESS_MESSAGES = {
  CHILD_KYC_SUCCESS: 'KYC verification has been done',
  ACCOUNT_CREATED_SUCCESS: 'Account created successfully',
}

export const CHILD_API_DETAILS = {
  UPDATE_CHILD: 'Update child',
  SEND_OTP_TO_AADHAR: 'Send OTP to AADHAR for verification',
  VERIFY_OTP_TO_AADHAR: 'Verify OTP to AADHAR for verification',
  UPDATED_TOKEN: 'updated token',
  GET_CHILD_PROFILE: 'child profile details',
  GET_WEIGHT_FOR_LENGTH_DATA: 'weight and length',
};

export const child_otp_const = {
  success: 'success',
  failed: 'failed',
  invalidOtp: 'Invalid OTP',
  runtimeError: 'Runtime Error',
  seconds30: '30 seconds',
  multipleOtps: 'multiple OTPs',
  missingCredentials: 'Missing Credentials',
  tooManyRequests: 'Too many request attempted',
  gatewayUnavailable: 'Aadhaar Gateway is unavailable',
  invalidLoginId: 'Invalid LoginId',
  invalidLoginHint: 'Invalid Login Hint',
};

export const ABDM_ERROR_CODES = {
  ABDM_1157: 'ABDM-1157'
}